// KEGG富集柱形图
import ChartTemplate from '../ChartTemplate';
import $ from '@/assets/jquery/jquery-vendor.js';
export default {
  extends: ChartTemplate,
  props: {
    config: {
      default: function () { return { group: -1, name: 1, x: 13, y: 1, z: 5, topX: 20,p:9 } }
    }
  },
  data () {
    return {
      srcSeries: null,
      extCPT: () => import('./ExtendComponent.vue')
    }
  },
  computed: {
    extCPTProps () {
      return {
        dataSourceParam: this.dataSourceParam,
        dataSource: this.dataSource
      }
    }
  },
  methods: {
    async initDataAfter () {
      // 对数据进行排序: 按照pValue
      this.dataSource = [this.dataSource[0], ...this.dataSource.slice(1).sort((a, b) => Number(a[9]) - Number(b[9]))];
      await require('highcharts/modules/heatmap')(this.Highcharts);
      (function (H) {
        var bubbleProto = H.seriesTypes.bubble.prototype;
        bubbleProto.axisTypes = ['xAxis', 'yAxis', 'colorAxis'];
        bubbleProto.optionalAxis = 'colorAxis';
        bubbleProto.colorKey = 'colorValue';
        bubbleProto.pointArrayMap = ['y', 'z', 'colorValue'];
        bubbleProto.parallelArrays = ['x', 'y', 'z', 'colorValue'];
        H.wrap(bubbleProto, 'translate', function (proceed) {
          proceed.apply(this, Array.prototype.slice.call(arguments, 1));
          H.seriesTypes.heatmap.prototype.translateColors.call(this);
        });
      })(this.Highcharts);
    },
    initOption () {
      let dataOption = this.getDataOption();
      let bubbleOption = this.getBubbleOption();
      this.Utility.deepMerge(this.chartOption, bubbleOption, dataOption, this.paramOption);
    },

    initOptionAfter () {
      this.srcSeries = this.Utility.clone(this.chartOption.series);
    },
    initChartAfter () {
      this.hideNumberCategory();
    },

    getBubbleOption () {
      return {
        chart: { animation: false, type: 'bubble' },
        credits: { enabled: false },
        title: { text: '' },
        tooltip: { headerFormat: '', pointFormat: '{point.z}' }, // {point.pValue:.2f}, 
        yAxis: {
          // min: 0,
          title: { text: null }, gridLineWidth: 0, tickmarkPlacement: 'on',
          tickWidth: 1,
          tickColor: '#00000066', tickLength: 5, lineWidth: 1, lineColor: '#00000066',
          labels: { step: 1, style: { textOverflow: 'none', whiteSpace: 'nowrap' } }
        },
        xAxis: { tickColor: '#00000066', tickLength: 5, tickWidth: 1, lineWidth: 1, lineColor: '#00000066' },
        colorAxis: { minColor: '#00FF00', maxColor: '#FF0000' },
        plotOptions: {
          bubble: {
            // sizeByAbsoluteValue:true,
            //minSize: 2, maxSize: 3 
            // minSize: 20,
            maxSize: '10%'
          },
          series: {
            colorByPoint: true, stickyTracking: false,
            turboThreshold: 0, dataLabels: { format: '{key}', crop: false, allowOverlap: true, overflow: 'none' }
          }
        }
      }
    },
    // ================ 获取GO富集的数据option
    getDataOption (srs) {
      let
        p1 = this.config.title == false ? false : true,
        p2 = this.config.group == null ? 0 : this.config.group,
        p3 = this.config.name == null ? 1 : this.config.name,
        p4 = this.config.x == null ? 2 : this.config.x,
        //p5 = this.config.y == null ? 3 : this.config.y,
        p6 = this.config.z == null ? 4 : this.config.z,
        p7 = this.config.topX;
      let rows;
      if (srs) rows = srs;
      else {
        rows = p1 ? this.dataSource.slice(1) : this.dataSource;
        if (p7) rows = rows.slice(0, p7);
      }
      // rows = rows.sort((a, b) => Number(a[pValueCol]) - Number(b[pValueCol])); // 按照pValue排序
      let ss = [], cts = [];
      for (let i = 0, l = rows.length; i < l; i++) {
        let r = rows[i];
        let sd;
        if (p2 != -1) sd = ss.find(t => t.name == r[p2]);
        else sd = ss[0];
        cts.push(r[p3]);
        let sdr = {
          x: Number(r[p4]), y: i, z: Number(r[p6]),
          colorValue: Number(r[this.config.p]), _sn: i, pValue: r[this.config.p]
        };
        if (p3 != -1) sdr.name = r[p3];
        if (sd) {
          sd.data.push(sdr);
        } else {
          sd = { data: [sdr] };
          if (p2 != -1) sd.name = r[p2];
          ss.push(sd);
        }
      }
      return {
        yAxis: {
          categories: cts,
          //max: cts.length - 1 
        },
        series: ss
      }
    },

    hideNumberCategory () {
      let yAxisTexts = $(`#${this.chartElId} .highcharts-yaxis-labels`).children();
      yAxisTexts.each(function () {
        let t = $(this).text();
        if (parseInt(t) == t) $(this).hide();
      })
    },

    // 扩展组件的表格行勾选事件
    onExtCPTChanged (srs) {
      let option = this.getDataOption(srs);
      this.chartOption.series = option.series;
      this.chartOption.yAxis.categories = option.yAxis.categories;
      this.chart.destroy();
      this.chart = this.Highcharts.chart(this.chartElId, this.chartOption);
      this.hideNumberCategory();
    }
  }
}


/*
// KEGG富集柱形图
import ChartTemplate from '../ChartTemplate';
import { Alpha } from '@/plugins/chart';

export default {
  extends: ChartTemplate,
  props: {
    config: {
      default: function () { return { group: -1, name: 2, x: 12, y: 2, z: 5, topX: 20 } }
    }
  },
  data () {
    return {
      srcSeries: null,
      extCPT: () => import('./ExtendComponent.vue')
    }
  },
  computed: {
    extCPTProps () {
      return { dataSourceParam: this.dataSourceParam, dataSource: this.dataSource }
    }
  },
  methods: {
    initOption () {
      let colorOption = this.getColorOption();
      let bubbleOption = this.getBubbleOption();
      let dataOption = this.getDataOption();
      this.Utility.deepMerge(this.chartOption, colorOption, bubbleOption, dataOption, this.paramOption);
    },

    initOptionAfter () {
      this.srcSeries = this.Utility.clone(this.chartOption.series);
    },


    onParamFormChangedBefore (e, item) {
      if (item.code === 'colors') {
        let color = e.split(',')[0];
        let colorOption = this.getColorOption(color);
        this.chart.update(colorOption);
        return false;
      }
    },


    // =============== 获取颜色的option
    getColorOption (color) {
      let step = 5, from = 100, len = parseInt(from / step);
      if (!color) color = this.Highcharts.getOptions().colors[0];
      color = color.substring(0, 7);
      let colors = [];
      for (let i = 0; i < len; i++) {
        let pct = from - i * step;
        if (pct < 0) break;
        colors.push(color + Alpha[pct]);
      }
      return { colors: colors };
    },
    // =============== 获取气泡图基础option
    getBubbleOption () {
      return {
        chart: { animation: false },
        credits: { enabled: false },
        legend: { enabled: false },
        title: { text: '' },
        yAxis: {
          title: { text: null }, gridLineWidth: 0, tickWidth: 0,
          tickColor: '#00000066', tickLength: 5, lineWidth: 1, lineColor: '#00000066',
          labels: { step: 1, style: { textOverflow: 'none', whiteSpace: 'nowrap' } }
        },
        xAxis: {
          tickColor: '#00000066', tickLength: 5, tickWidth: 1, lineWidth: 1, lineColor: '#00000066'
        },
        plotOptions: {
          series: { colorByPoint: true, stickyTracking: false, turboThreshold: 0 }
        }
      }
    },
    // ================ 获取GO富集的数据option
    getDataOption () {
      let pValueCol = 9;
      let
        p1 = this.config.title == false ? false : true,
        p2 = this.config.group == null ? 0 : this.config.group,
        p3 = this.config.name == null ? 1 : this.config.name,
        p4 = this.config.x == null ? 2 : this.config.x,
        //p5 = this.config.y == null ? 3 : this.config.y,
        p6 = this.config.z == null ? 4 : this.config.z,
        p7 = this.config.topX;

      let rows = p1 ? this.dataSource.slice(1) : this.dataSource;
      if (p7) rows = rows.slice(0, p7);
      rows = rows.sort((a, b) => Number(a[pValueCol]) - Number(b[pValueCol])); // 按照pValue排序
      let ss = [], cts = [];
      for (let i = 0, l = rows.length; i < l; i++) {
        let r = rows[i];
        let sd;
        if (p2 != -1) sd = ss.find(t => t.name == r[p2]);
        else sd = ss[0];
        cts.push(r[p3]);
        let sdr = { x: Number(r[p4]), y: i, z: Number(r[p6]), _sn: i, pValue: r[pValueCol] };
        if (p3 != -1) sdr.name = r[p3];
        if (sd) {
          sd.data.push(sdr);
        } else {
          sd = { data: [sdr] };
          if (p2 != -1) sd.name = r[p2];
          ss.push(sd);
        }
      }
      return {
        chart: { type: 'bubble' },
        tooltip: { headerFormat: '', pointFormat: '{point.pValue:.2f}, {point.z}' },
        plotOptions: { series: { dataLabels: { format: '{key}', crop: false, allowOverlap: true, overflow: 'none' } } },
        yAxis: { categories: cts },
        series: ss
      }
    },

    // 扩展组件的表格行勾选事件
    onExtCPTChanged (sri) {
      let newSeries = [{ data: this.srcSeries[0].data.filter(row => sri.indexOf(row._sn) != -1) }];
      let color = this.chartOption.colors[0];
      let colorOption = this.getColorOption(color);
      let seriesOption = { series: newSeries };
      this.chart.update({ ...seriesOption, ...colorOption });
    }
  }
}
*/